/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "abec9ae864466e276e946d8778d85f2e9b813b2e";
